import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class'

import * as fieldComponents from '../../components/fields/number-text-v1/number-text-v1-index'

@Injectable({
    providedIn: 'root'
  })
export class NumberTextV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'number-text-v1';
    menuTitle: string = "Number Field";
    deprecated: boolean = false;

    /**
     * 
     * @param field the object data of the field
     * @returns NumberTextV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.NumberTextV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsNumberTextV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsNumberTextV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        return new fields.SettingsNumberTextV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
    }


    getSettingsComponentType(): Type<fieldComponents.SettingsNumberTextV1FieldComponent> {
        return fieldComponents.SettingsNumberTextV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillNumberTextV1FieldComponent> {
        return fieldComponents.FillNumberTextV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewNumberTextV1FieldComponent>{ 
        return fieldComponents.ViewNumberTextV1FieldComponent;
    }


}